import { createSlice } from "@reduxjs/toolkit";
import { TokensApi } from "../action/cryptotokenAction";

const cryptotokenReducer = createSlice({
	name: "tokenApi",
	initialState: {
		TokenData: [],
		loading: false,
		errors: {},
	},
	reducers: {},
	extraReducers: {
		[TokensApi.pending]: (state) => {
			state.loading = true;
		},
		[TokensApi.fulfilled]: (state, action) => {
			state.loading = false;
			state.TokenData = action.payload.response;
		},
		[TokensApi.rejected]: (state, action) => {
			state.loading = false;
			state.errors = action.payload;
		},
	},
});

export default cryptotokenReducer.reducer;
